import { TableColumn } from '@ui/aos-lib';
import { EquipmentListingFieldName } from 'src/app/pages/equipment/devices/components/devices.models';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { ReportNameColumnComponent } from './components/report-name-column/report-name-column.component';

/**
 * Search/sort field names. Values intentionally match the `Report` property keys so the
 * client-side data source can index reports directly by the payload's search/sort fields.
 */
export enum ReportsFieldName {
  Name = 'title',
  Category = 'category',
  Owner = 'owner',
  LastModified = 'lastModified',
  Status = 'status'
}

export const SEARCH_TYPES = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.NAME,
    value: 1,
    types: [ReportsFieldName.Name],
    hintText: SEARCH_HINTS.Search
  }
];

export const reportsTableConfig: TableColumn[] = [
  {
    field: 'title',
    title: TranslateRegistry.get.REPORTS.TABLE.NAME,
    width: 300,
    sortable: true,
    cmp: ReportNameColumnComponent
  },
  { field: 'category', title: TranslateRegistry.get.REPORTS.TABLE.CATEGORY, width: 200, sortable: true },
  { field: 'owner', title: TranslateRegistry.get.REPORTS.TABLE.OWNER, width: 200, sortable: true },
  { field: 'lastModified', title: TranslateRegistry.get.REPORTS.TABLE.LAST_MODIFIED, width: 200, sortable: true },
  { field: 'status', title: TranslateRegistry.get.REPORTS.TABLE.STATUS, width: 144, sortable: true }
];

export const reportsTableSortField: Record<string, EquipmentListingFieldName> = {
  title: ReportsFieldName.Name,
  category: ReportsFieldName.Category,
  owner: ReportsFieldName.Owner,
  lastModified: ReportsFieldName.LastModified,
  status: ReportsFieldName.Status
};
